let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fY8rF")).then(() => parcelRequire('jlGi5'));